import { ReactElement, Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";
import { Loading } from "./components/Loading";

const Map = lazy(() => import("./Map"));
const Create = lazy(() => import("./Create"));
const Login = lazy(() => import("./Login"));
const PlaceDetail = lazy(() => import("./components/PlaceDetail"));
const LegalPage = lazy(() => import("./Privacidad"));
const EditPlace = lazy(() => import("./Edit"));
const EventoAltaPage = lazy(() => import("./Eventos/EventoAltaPage"));
const EventoList = lazy(() => import("./Eventos/EventoList"));
const EventoDetalle = lazy(() => import("./Eventos/EventoDetalle"));
const PlaceListWithSearch = lazy(() => import("./components/PlaceListWithSearch"));
const TematicaDetails = lazy(() => import("./components/TematicaDetails"));
const PlanSalidaPage = lazy(() => import("./PlanSalida/PlanSalidaPage"));
const BarrioDetail = lazy(() => import("./components/BarrioDetail"));
const BajoTechoAdmin = lazy(() => import("./admin/BajoTechoAdmin"));

const AppRouter = (): ReactElement => {
  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        <Route path="/" element={<Map />} />
        <Route path="/create" element={<Create />} />
        <Route path="/login" element={<Login />} />
        <Route path="/lugar/:slug/:id" element={<PlaceDetail />} />
        <Route path="/lugar/:id" element={<PlaceDetail />} />
        <Route path="/privacidad" element={<LegalPage />} />
        <Route path="/editar/:id" element={<EditPlace />} />
        <Route path="/evento/crear" element={<EventoAltaPage />} />
        <Route path="/eventos" element={<EventoList />} />
        <Route path="/lista" element={<PlaceListWithSearch />} />
        <Route path="/eventos/editar/:id" element={<EventoAltaPage />} />
        <Route path="/eventos/:id" element={<EventoDetalle />} />
        <Route path="/tematica/:slug/:id" element={<TematicaDetails />} />
        <Route path="/plan-salida" element={<PlanSalidaPage />} />
        <Route path="/barrio/:slug" element={<BarrioDetail />} />
        <Route path="/admin/bajo-techo" element={<BajoTechoAdmin />} />
      </Routes>
    </Suspense>
  );
};

export default AppRouter;
